export default function EmptyState({ icon = '\u2713', text = 'No issues found' }) {
  return (
    <div className="text-center py-16 text-gray-400">
      <div className="text-4xl mb-3">{icon}</div>
      <div className="font-semibold text-sm">{text}</div>
    </div>
  );
}
